/**
 * Dial codes for admin forms (create app user, edit profile, admin panel users).
 * Sorted longest-first for parsing numbers that start with a code.
 */
export const PHONE_DIAL_CODES = [
  { code: "+358", country: "Finland" },
  { code: "+880", country: "Bangladesh" },
  { code: "+971", country: "UAE" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+977", country: "Nepal" },
  { code: "+234", country: "Nigeria" },
  { code: "+254", country: "Kenya" },
  { code: "+92", country: "Pakistan" },
  { code: "+91", country: "India" },
  { code: "+86", country: "China" },
  { code: "+81", country: "Japan" },
  { code: "+82", country: "South Korea" },
  { code: "+84", country: "Vietnam" },
  { code: "+90", country: "Turkey" },
  { code: "+94", country: "Sri Lanka" },
  { code: "+65", country: "Singapore" },
  { code: "+60", country: "Malaysia" },
  { code: "+62", country: "Indonesia" },
  { code: "+66", country: "Thailand" },
  { code: "+61", country: "Australia" },
  { code: "+64", country: "New Zealand" },
  { code: "+55", country: "Brazil" },
  { code: "+52", country: "Mexico" },
  { code: "+54", country: "Argentina" },
  { code: "+27", country: "South Africa" },
  { code: "+20", country: "Egypt" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+39", country: "Italy" },
  { code: "+34", country: "Spain" },
  { code: "+31", country: "Netherlands" },
  { code: "+32", country: "Belgium" },
  { code: "+41", country: "Switzerland" },
  { code: "+46", country: "Sweden" },
  { code: "+47", country: "Norway" },
  { code: "+45", country: "Denmark" },
  { code: "+48", country: "Poland" },
  { code: "+351", country: "Portugal" },
  { code: "+44", country: "UK" },
  { code: "+1", country: "USA/Canada" },
  { code: "+7", country: "Russia" },
].sort((a, b) => b.code.length - a.code.length);

const DEFAULT_DIAL = "+92";

/**
 * Split stored contact (e.g. +923001234567) into dial code + national digits.
 */
export function parseContactForDialSelect(contactNo) {
  const raw = String(contactNo || "").trim();
  if (!raw) return { dial: DEFAULT_DIAL, national: "" };
  for (const pc of PHONE_DIAL_CODES) {
    if (raw.startsWith(pc.code)) {
      return {
        dial: pc.code,
        national: raw.slice(pc.code.length).replace(/\D/g, ""),
      };
    }
  }
  if (raw.startsWith("+")) {
    const digits = raw.slice(1).replace(/\D/g, "");
    return { dial: DEFAULT_DIAL, national: digits };
  }
  return { dial: DEFAULT_DIAL, national: raw.replace(/\D/g, "") };
}

/** Combine dial + digits only (no spaces). Backend normalizes further. */
export function buildFullContactNo(dial, nationalDigits) {
  const d = String(nationalDigits || "").replace(/\D/g, "");
  const prefix = String(dial || DEFAULT_DIAL).trim();
  return `${prefix}${d}`;
}

/** Latest calendar date (YYYY-MM-DD) for someone who is exactly 18 today. */
export function maxBirthDateIsoForAge18() {
  const t = new Date();
  t.setFullYear(t.getFullYear() - 18);
  const y = t.getFullYear();
  const m = String(t.getMonth() + 1).padStart(2, "0");
  const d = String(t.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function minBirthDateIso120Years() {
  const t = new Date();
  t.setFullYear(t.getFullYear() - 120);
  const y = t.getFullYear();
  const m = String(t.getMonth() + 1).padStart(2, "0");
  const d = String(t.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
